import React from "react";
import { Box } from "@mui/material";
import LoginScreen from "./LoginScreen";
import { useUserContext } from "../context/UserContext";
import HomeScreen from "./HomeScreen";
import useDeviceDetection from "../utils/useDeviceDetection";
import MobileHomeScreen from "./MobileHomeScreen";
export interface User {
    id: string;
    name: string;
    lunchOpted: boolean;
    designation: string;
}

const MainScreen: React.FC = () => {
    const { currentUser } = useUserContext();
    const { isMobile } = useDeviceDetection();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100vw", alignItems: "center", justifyContent: "center", flex: 1, py: 2, px: 4 }}>
            {!currentUser ?
                <LoginScreen />
                :
                isMobile ? <MobileHomeScreen />
                    :
                    <HomeScreen />
            }
        </Box>
    );
};

export default MainScreen;